import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import config from "./config/config";
import store from "./redux/store";
import "./static/css/newStyle.css";
import GlobalStyle from "./styles/globalStyle";
import Auth from "./routes/login";
import ProtectedRoute from "./components/utilities/protectedRoute";
import Dashboard from "./container/dashboard/Index";
import Masters from "./container/customerCare/masters/Index";
import OtherBranchStock from "./container/customerCare/other-branch-stock/Index";
import SalesInvoice from "./container/customerCare/sales-invoice/Index";
import ImeiSearch from "./container/customerCare/imei-search/Index";
import PushLead from "./container/customerCare/push-lead/Index";
import AboutSearchProduct from "./container/about/SearchProduct";
import AdminLayout from "./layout/AdminLayout";

const { theme } = config;

const AppRoutes = () => {
  const isLoggedIn = useSelector((state) => state.auth.login);
  const rtl = false;
  const topMenu = true;
  const darkMode = false;

  return (
    <ConfigProvider
      direction={rtl ? "rtl" : "ltr"}
      theme={{
        token: {
          fontFamily:
            'Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        },
      }}
    >
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <GlobalStyle />
        <Routes>
          <Route
            path="/login"
            element={
              !isLoggedIn ? <Auth /> : <Navigate to="/dashboard" replace />
            }
          />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/masters" element={<Masters />} />
              <Route path="/other-branch-stock" element={<OtherBranchStock />} />
              <Route path="/sales-invoice" element={<SalesInvoice />} />
              <Route path="/imei-search" element={<ImeiSearch />} />
              <Route path="/push-lead" element={<PushLead />} />
              <Route path="/about-2-0" element={<AboutSearchProduct />} />
            </Route>
          </Route>
          <Route
            path="*"
            element={
              <Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />
            }
          />
        </Routes>
      </ThemeProvider>
    </ConfigProvider>
  );
};

const App = () => (
  <Provider store={store}>
    <Router basename={process.env.PUBLIC_URL}>
      <AppRoutes />
    </Router>
  </Provider>
);

export default App;
